import React from 'react';
import { View } from 'react-native';
import Svg, { Circle, Line, Path } from 'react-native-svg';

interface EyeIconProps {
    size?: number;
    color?: string;
    isVisible?: boolean;
}

export const EyeIcon: React.FC<EyeIconProps> = ({
    size = 24,
    color = 'currentColor',
    isVisible = true
}) => {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <Svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2">
                {isVisible ? (
                    // Eye open icon
                    <>
                        <Path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                        <Circle cx="12" cy="12" r="3" />
                    </>
                ) : (
                    // Eye closed icon
                    <>
                        <Path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                        <Line x1="1" y1="1" x2="23" y2="23" />
                    </>
                )}
            </Svg>
        </View>
    );
};